"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _VolumeControl = require("./VolumeControl");
Object.keys(_VolumeControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VolumeControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VolumeControl[key];
    }
  });
});